export const thumbailForSpeaker = (speaker) => {
    if (speaker.profile_image?.length && speaker.profile_image[0]?.thumbnails?.large) {
        return speaker.profile_image[0].thumbnails.large;
    }
    return null;
}